<template>
    <v-row no-gutters class="justify-center">

        <v-col cols="10" sm="8" md="6" class="d-flex flex-column justify-center align-center">
            <QuestRoute class="w-100"></QuestRoute>


            <span class="empty-list-title mt-7 text-center">
                The Hunter's Path Awaits!
            </span>


            <span class="empty-list-subtitle mt-1 text-center">
                <slot name="title">
                    Sorry, we couldn't find any results matching your search criteria
                </slot>
            </span>
        </v-col>

    </v-row>
</template>



<script setup>

import QuestRoute from "@/icons/QuestRoute.vue";

</script>
<!-- TODO: we need to discuss and decide the font size and weight for the mobile for this component -->